import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { GrupoTransacao } from '../classes/GrupoTransacao';

@Injectable({
  providedIn: 'root'
})
export class GrupoTransacaoService {

  constructor(private http: HttpClient) { }

  getList(): Observable<any>{
    return this.http.get(`${environment.apiURL}/grupoTransacao`)
  }

  get(id:number): Observable<any>{
    return this.http.get(`${environment.apiURL}/grupoTransacao/${id}`)
  }

  post(grupoTransacao: GrupoTransacao): Observable<any>{
    return this.http.post(`${environment.apiURL}/grupoTransacao`, grupoTransacao);
  }

  put(id: number, grupoTransacao: GrupoTransacao): Observable<any>{
    return this.http.put(`${environment.apiURL}/grupoTransacao/${id}`, grupoTransacao);
  }

  delete(id: number): Observable<any>{
    return this.http.delete(`${environment.apiURL}/grupoTransacao/${id}`);
  }
}
